<app-self-checkin kind="group" [targetId]="targetId"></app-self-checkin>
